<template>
  <div>
    <FloatingMenu />
    <MenuBar />

    <div id="resultsPage">
      <transition enter-active-class="animated fadeIn" appear>
        <div class="resultPageTitle">
          <span v-if="this.langChosen === 'gr'">ผลลัพธ์ทั้งหมด</span>
          <span v-else>All Results</span>
        </div>
      </transition>

      <div class="resultField">
        <div class="resultContainer" v-for="(result, index) in resultData" :key="index">
          <div class="topSection">
            <div>{{ dateFormatter(result.date) }}</div>
            <div class="resultText">{{ result.result }}</div>
          </div>

          <div class="bottomSection">
            <div class="ballNumber">{{ result.bolaSatu }}</div>
            <div class="ballNumber">{{ result.bolaDua }}</div>
            <div class="ballNumber">{{ result.bolaTiga }}</div>
            <div class="ballNumber">{{ result.bolaEmpat }}</div>
            <div class="ballNumber">{{ result.bolaLima }}</div>
            <div class="ballNumber">{{ result.bolaEnam }}</div>
            <div class="plusSign">+</div>
            <div class="ballNumber additionalBall">{{ result.additionalNumber }}</div>
          </div>
        </div>
      </div>
    </div>

    <div id="resultsDesktop">
      <div class="heroHeader">
        <transition enter-active-class="animated fadeIn" appear>
          <div>
            <span v-if="this.langChosen === 'gr'">ผล</span>
            <span v-else>Results</span>
          </div>
        </transition>
      </div>

      <div class="flex">
        <div class="adsSpace1 desktopOnly">
          <a href="http://discoverthailandco.com" target="_blank">Bangkok. Enjoy your moment.</a>
        </div>

        <div class="resultDesktopField">
          <div class="resultContainer" v-for="(result, index) in resultData" :key="index">
            <div class="resultContainerLeft">
              <div class="year">{{ new Date(result.date).getFullYear() }}</div>
              <div class="date">{{ new Date(result.date).getDate() }}</div>
              <div class="month">{{ monthToString(new Date(result.date).getMonth()) }}</div>
            </div>

            <div class="resultContainerRight">
              <div class="rightTop">
                <div class="ballNumber">{{ result.bolaSatu }}</div>
                <div class="ballNumber">{{ result.bolaDua }}</div>
                <div class="ballNumber">{{ result.bolaTiga }}</div>
                <div class="ballNumber">{{ result.bolaEmpat }}</div>
                <div class="ballNumber">{{ result.bolaLima }}</div>
                <div class="ballNumber">{{ result.bolaEnam }}</div>
                <div class="plusSign">+</div>
                <div class="ballNumber additionalBall">{{ result.additionalNumber }}</div>
              </div>

              <div class="rightBottom">Result: {{ result.result }}</div>
            </div>
          </div>
        </div>

        <div class="adsSpace2 desktopOnly">
          <a href="https://www.tourismthailand.org" target="_blank">Visit Thailand!</a>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import FloatingMenu from '../components/FloatingMenu';
import MenuBar from '../components/MenuBar';
import Footer from '../components/FifthSection';

export default {
  components: {
    FloatingMenu,
    MenuBar,
    Footer,
  },
  data: function() {
    return {
      resultData: [],
      pageLoaded: 1,
    };
  },
  methods: {
    getAllResults(page) {
      fetch(`/api/allResults?page=${page}`)
        .then(response => {
          if (response.ok) {
            response.json().then(res => {
              this.resultData = this.resultData.concat(res);
            });
          } else {
            alert('Please check your connection and try again.');
          }
        })
        .catch(() => {
          alert('Please check your connection and try again.');
        });
    },
    triggerInfScroll() {
      const resultField = document.querySelector('.resultField');
      resultField.addEventListener('scroll', () => {
        if (resultField.scrollTop + resultField.clientHeight + 1 >= resultField.scrollHeight) {
          this.pageLoaded++;
          this.getAllResults(this.pageLoaded);
        }
      });
    },
    triggerInfScrollDesktop() {
      const resultField = document.querySelector('.resultDesktopField');
      resultField.addEventListener('scroll', () => {
        if (resultField.scrollTop + resultField.clientHeight + 1 >= resultField.scrollHeight) {
          this.pageLoaded++;
          this.getAllResults(this.pageLoaded);
        }
      });
    },
    dateFormatter(date) {
      const dateObj = new Date(date);

      if (this.langChosen === 'gr') {
        let dateDay = '';
        switch (dateObj.getDay()) {
          case 0:
            dateDay = 'วันอาทิตย์';
            break;
          case 1:
            dateDay = 'วันจันทร์';
            break;
          case 2:
            dateDay = 'วันอังคาร';
            break;
          case 3:
            dateDay = 'วันพุธ';
            break;
          case 4:
            dateDay = 'วันพฤหัสบดี';
            break;
          case 5:
            dateDay = 'วันศุกร์';
            break;
          case 6:
            dateDay = 'วันเสาร์';
            break;
        }

        let dateMonth = '';
        switch (dateObj.getMonth()) {
          case 0:
            dateMonth = 'มกราคม';
            break;
          case 1:
            dateMonth = 'กุมภาพันธ์';
            break;
          case 2:
            dateMonth = 'มีนาคม';
            break;
          case 3:
            dateMonth = 'เมษายน';
            break;
          case 4:
            dateMonth = 'อาจ';
            break;
          case 5:
            dateMonth = 'มิถุนายน';
            break;
          case 6:
            dateMonth = 'กรกฎาคม';
            break;
          case 7:
            dateMonth = 'สิงหาคม';
            break;
          case 8:
            dateMonth = 'กันยายน';
            break;
          case 9:
            dateMonth = 'ตุลาคม';
            break;
          case 10:
            dateMonth = 'พฤศจิกายน';
            break;
          case 11:
            dateMonth = 'ธันวาคม';
            break;
        }

        return `${dateDay}, ${dateObj.getDate()} ${dateMonth} ${dateObj.getFullYear()}`;
      } else {
        let dateDay = '';
        switch (dateObj.getDay()) {
          case 0:
            dateDay = 'Sunday';
            break;
          case 1:
            dateDay = 'Monday';
            break;
          case 2:
            dateDay = 'Tuesday';
            break;
          case 3:
            dateDay = 'Wednesday';
            break;
          case 4:
            dateDay = 'Thursday';
            break;
          case 5:
            dateDay = 'Friday';
            break;
          case 6:
            dateDay = 'Saturday';
            break;
        }

        let dateMonth = '';
        switch (dateObj.getMonth()) {
          case 0:
            dateMonth = 'January';
            break;
          case 1:
            dateMonth = 'February';
            break;
          case 2:
            dateMonth = 'March';
            break;
          case 3:
            dateMonth = 'April';
            break;
          case 4:
            dateMonth = 'May';
            break;
          case 5:
            dateMonth = 'June';
            break;
          case 6:
            dateMonth = 'Juli';
            break;
          case 7:
            dateMonth = 'August';
            break;
          case 8:
            dateMonth = 'September';
            break;
          case 9:
            dateMonth = 'October';
            break;
          case 10:
            dateMonth = 'November';
            break;
          case 11:
            dateMonth = 'December';
            break;
        }

        return `${dateDay}, ${dateObj.getDate()} ${dateMonth} ${dateObj.getFullYear()}`;
      }
    },
    setDocTitle() {
      if (localStorage.getItem('langChosen') === 'gr') {
        document.title = 'ผล - ลอตเตอรี่กรุงเทพ';
      } else {
        document.title = 'Results - Bangkok Lotteries';
      }
    },
    monthToString(number) {
      switch (number) {
        case 0:
          return 'January';
        case 1:
          return 'February';
        case 2:
          return 'March';
        case 3:
          return 'April';
        case 4:
          return 'May';
        case 5:
          return 'June';
        case 6:
          return 'July';
        case 7:
          return 'August';
        case 8:
          return 'September';
        case 9:
          return 'October';
        case 10:
          return 'November';
        case 11:
          return 'December';
      }
    },
  },
  mounted() {
    this.triggerInfScroll();
    this.setDocTitle();
    this.getAllResults(this.pageLoaded);
    this.triggerInfScrollDesktop();
  },
};
</script>

<style>
#resultsPage {
  background: url('../assets/backgroundFirstSection.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 100vw;
  min-height: 100vh;
  padding: 5vw;
  padding-top: 7.5vw;
  box-sizing: border-box;
}

.resultPageTitle {
  font-size: 165%;
  font-weight: bold;
  color: var(--lightColor);
}

.resultField {
  margin-top: 5vw;
  height: 87vh;
  overflow: auto;
}

.topSection,
.bottomSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.resultContainer {
  background-color: rgba(247, 243, 244, 0.8);
  border-radius: 1.5vw;
  overflow: hidden;
  margin-bottom: 5vw;
}

.topSection {
  background: rgba(204, 172, 119, 0.6);
  color: var(--darkColor);
  font-weight: bold;
  padding: 3vw 3.5vw;
}

.bottomSection {
  padding: 3.5vw 2.5vw;
}

.resultText {
  text-decoration: underline;
  color: var(--bluePrim-darker-6);
}

.ballNumber {
  border-radius: 50%;
  background-color: white;
  font-size: 125%;
  box-sizing: border-box;
  width: 10vw;
  height: 10vw;
  max-width: 50px;
  max-height: 50px;
  color: var(--lightColor);
  font-weight: 600;
  background-image: linear-gradient(135deg, var(--yellowPrim-darker-1), var(--yellowPrim-darker-4));
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.plusSign {
  font-size: 125%;
  font-weight: 600;
  color: var(--yellowPrim-darker-4);
}

.additionalBall {
  background-image: linear-gradient(135deg, var(--bluePrim-darker-1), var(--bluePrim-darker-4));
}

@media screen and (min-width: 768px) {
  #resultsPage {
    display: none;
  }

  #resultsDesktop {
    background-color: var(--darkColor);
    min-height: 100vh;
  }

  #resultsDesktop .heroHeader {
    background-image: url('../assets/hero-header-results-page.jpg');
    text-align: center;
    font-size: 6em;
    font-weight: bold;
    color: white;
    padding: 138px 0;
    background-position: center;
    text-shadow: 1px 1px 4px black;
  }

  .resultDesktopField {
    width: 60%;
    margin: auto;
    height: 600px;
    overflow: scroll;
    background: var(--bluePrim-lighter-4);
    position: relative;
    top: -50px;
    padding: 30px;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    margin-bottom: -50px;
  }

  .resultContainer {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    border-radius: 5px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }

  .rightTop {
    display: flex;
    justify-content: space-between;
    padding: 15px 90px 5px 90px;
    align-items: center;
  }

  .rightBottom {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-grow: 1;
    font-weight: bold;
    color: var(--darkColor);
    letter-spacing: 1px;
  }

  .resultContainerLeft {
    display: flex;
    flex-direction: column;
    width: 15%;
    background-color: var(--darkColor);
  }

  .year,
  .month {
    font-size: 0.9em;
  }

  .year {
    padding-bottom: 0;
    padding: 10px 10px 0 10px;
    color: var(--bluePrim-lighter-1);
  }

  .date {
    font-size: 3em;
    font-weight: bold;
    padding: 0px 15px;
    color: var(--lightColor);
  }

  .month {
    padding-bottom: 10px;
    color: var(--bluePrim-lighter-1);
  }

  .date,
  .year,
  .month {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }

  .date {
    flex-grow: 1;
  }

  .resultContainerRight {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  #resultsDesktop .adsSpace1,
  #resultsDesktop .adsSpace2 {
    width: 18%;
    position: relative;
    z-index: 3;
    text-align: center;
    border-radius: 5px;
    top: -50px;
    margin-bottom: -50px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }
}
</style>
